// @ts-nocheck
import type { Question } from '../types';

export const specializedDrivingQuestions: Question[] = [
  {
    id: 'q-spd-1',
    topic: 'General',
    question: 'What is the maximum speed on a Dutch motorway when towing a trailer with a category B licence?',
    options: [
      { id: 'q-spd-1o1', text: '100 km/h' },
      { id: 'q-spd-1o2', text: '120 km/h' },
      { id: 'q-spd-1o3', text: '90 km/h' },
      { id: 'q-spd-1o4', text: '80 km/h' },
    ],
    answerId: 'q-spd-1o3',
    explanation: 'When towing a trailer with a category B licence, the maximum speed on a Dutch motorway is 90 km/h — even if the motorway limit is higher. This applies regardless of trailer weight. (RVV 1990 art. 22)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-2',
    topic: 'General',
    question: 'What is the maximum permitted mass of an unbraked trailer towed by a category B vehicle?',
    options: [
      { id: 'q-spd-2o1', text: '500 kg' },
      { id: 'q-spd-2o2', text: '750 kg' },
      { id: 'q-spd-2o3', text: '1000 kg' },
      { id: 'q-spd-2o4', text: '1500 kg' },
    ],
    answerId: 'q-spd-2o2',
    explanation: 'An unbraked trailer (one without its own braking system) may not exceed 750 kg maximum permitted mass. Above this, the trailer must have its own brakes. (Voertuigreglement art. 5.1.44)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-3',
    topic: 'General',
    question: 'A load extends more than 1 metre beyond the rear of your vehicle. What must you do?',
    options: [
      { id: 'q-spd-3o1', text: 'Attach a white reflector to the end of the load' },
      { id: 'q-spd-3o2', text: 'Mark the end of the load with a red/white striped board and a red reflector' },
      { id: 'q-spd-3o3', text: 'No marking is required for loads under 3 metres overhang' },
      { id: 'q-spd-3o4', text: 'Drive only during daylight hours' },
    ],
    answerId: 'q-spd-3o2',
    explanation: 'If a load extends more than 1 metre beyond the rear of the vehicle, the protruding end must be marked with a red/white striped board (chevron board) and a red reflector, visible from behind. At night or in poor visibility, a red light is also required. (RVV 1990 art. 76)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-4',
    topic: 'General',
    question: 'Are passengers allowed to travel inside a closed trailer being towed on a public road?',
    options: [
      { id: 'q-spd-4o1', text: 'Yes, if they are seated and belted' },
      { id: 'q-spd-4o2', text: 'Yes, but only on roads with a speed limit of 30 km/h or less' },
      { id: 'q-spd-4o3', text: 'No, passengers are never permitted in trailers' },
      { id: 'q-spd-4o4', text: 'Yes, if the trailer has windows' },
    ],
    answerId: 'q-spd-4o3',
    explanation: 'Passengers are never permitted to travel inside a trailer on a public road. The only occupants allowed in a moving vehicle are those in the designated passenger compartment of the towing vehicle. (RVV 1990 art. 61)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-5',
    topic: 'General',
    question: 'Your trailer is wider than your towing vehicle. What is required?',
    options: [
      { id: 'q-spd-5o1', text: 'Nothing — the trailer width makes no difference' },
      { id: 'q-spd-5o2', text: 'Fit extended side mirrors on the towing vehicle' },
      { id: 'q-spd-5o3', text: 'Reduce speed to 60 km/h on all roads' },
      { id: 'q-spd-5o4', text: 'Attach orange marker lights to the sides of the trailer' },
    ],
    answerId: 'q-spd-5o2',
    explanation: 'When a trailer is wider than the towing vehicle, you must fit extended (towing) mirrors so you can see along both sides of the trailer. Without adequate rearward visibility it is illegal to tow. (RVV 1990 art. 78)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-6',
    topic: 'General',
    question: 'While towing a trailer at 80 km/h, the trailer begins to sway from side to side. What should you do?',
    options: [
      { id: 'q-spd-6o1', text: 'Brake hard to stop the swaying immediately' },
      { id: 'q-spd-6o2', text: 'Steer sharply in the opposite direction to counteract the sway' },
      { id: 'q-spd-6o3', text: 'Ease off the accelerator gradually and hold the steering wheel firmly — do not brake hard' },
      { id: 'q-spd-6o4', text: 'Accelerate to drive out of the sway' },
    ],
    answerId: 'q-spd-6o3',
    explanation: 'When a trailer sways (snakes), gently ease off the accelerator and grip the steering wheel firmly — do not steer sharply or brake hard. Braking hard or sudden steering can cause a jackknife or rollover. Slowing gradually allows the trailer to stabilise.',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-7',
    topic: 'General',
    question: 'Which number plate must a trailer display?',
    options: [
      { id: 'q-spd-7o1', text: 'Its own separate registered plate' },
      { id: 'q-spd-7o2', text: 'The same plate as the towing vehicle' },
      { id: 'q-spd-7o3', text: 'No plate is required for trailers under 750 kg' },
      { id: 'q-spd-7o4', text: 'A temporary paper plate issued by the RDW' },
    ],
    answerId: 'q-spd-7o2',
    explanation: 'In the Netherlands, a trailer must display the same registration plate as the towing vehicle. The plate is mounted at the rear of the trailer and must be illuminated at night. (Voertuigreglement)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-8',
    topic: 'General',
    question: 'How should you load a trailer to ensure stable towing?',
    options: [
      { id: 'q-spd-8o1', text: 'Place the heaviest items at the rear of the trailer' },
      { id: 'q-spd-8o2', text: 'Place the heaviest items at the front (above the axle) and keep the load centred' },
      { id: 'q-spd-8o3', text: 'Distribute the load evenly from side to side only — front-rear position does not matter' },
      { id: 'q-spd-8o4', text: 'Load does not affect stability as long as the total weight is within limits' },
    ],
    answerId: 'q-spd-8o2',
    explanation: 'The heaviest items should be placed over or just in front of the trailer axle, centred side-to-side. This keeps downward pressure on the tow ball (noseweight) within the recommended range (typically 25–75 kg) and prevents the trailer from swaying.',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-9',
    topic: 'General',
    question: 'What lights must a trailer have when driving on a public road at night?',
    options: [
      { id: 'q-spd-9o1', text: 'Only rear reflectors — no active lights required' },
      { id: 'q-spd-9o2', text: 'Rear position lights, brake lights, indicators and number plate light' },
      { id: 'q-spd-9o3', text: 'Rear position lights only' },
      { id: 'q-spd-9o4', text: 'The trailer uses the towing vehicle lights — no separate lights needed' },
    ],
    answerId: 'q-spd-9o2',
    explanation: 'A trailer must have functioning rear position lights (tail lights), brake lights, direction indicators, a number plate light, and red rear reflectors. These are required by law and must be connected and operational before driving. (Voertuigreglement art. 3.7)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-10',
    topic: 'General',
    question: 'What is the maximum load overhang permitted at the front of a vehicle?',
    options: [
      { id: 'q-spd-10o1', text: '0.5 metres' },
      { id: 'q-spd-10o2', text: '1 metre' },
      { id: 'q-spd-10o3', text: '2 metres' },
      { id: 'q-spd-10o4', text: 'There is no front overhang limit' },
    ],
    answerId: 'q-spd-10o2',
    explanation: 'A load may not protrude more than 1 metre beyond the front of the vehicle. If it does, special permits and markings are required. The rear overhang limit without special permits is 3 metres beyond the rear of the vehicle. (RVV 1990 art. 76)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-11',
    topic: 'General',
    question: 'You are transporting an unsecured load of loose gravel in an open trailer. What is the risk and what must you do?',
    options: [
      { id: 'q-spd-11o1', text: 'No risk — small loose material does not need securing' },
      { id: 'q-spd-11o2', text: 'Cover the load with a tarpaulin to prevent material from blowing onto the road' },
      { id: 'q-spd-11o3', text: 'Drive only on roads with a 30 km/h limit' },
      { id: 'q-spd-11o4', text: 'Fill the trailer no more than halfway' },
    ],
    answerId: 'q-spd-11o2',
    explanation: 'Loose loads such as gravel, sand, or debris must be covered (e.g. with a tarpaulin or net) to prevent material falling onto the road. Material falling from vehicles creates a serious hazard for other road users and can result in fines. (Wegenverkeerswet art. 5)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-12',
    topic: 'General',
    question: 'What is the maximum width of a trailer or load permitted on Dutch roads without a special permit?',
    options: [
      { id: 'q-spd-12o1', text: '2.00 metres' },
      { id: 'q-spd-12o2', text: '2.30 metres' },
      { id: 'q-spd-12o3', text: '2.55 metres' },
      { id: 'q-spd-12o4', text: '3.00 metres' },
    ],
    answerId: 'q-spd-12o3',
    explanation: 'The maximum permitted width for a trailer or load without a special exemption permit is 2.55 metres. Loads or trailers wider than this require a special permit, escort vehicles, and specific route planning. (Voertuigreglement art. 5.2.1)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-13',
    topic: 'General',
    question: 'You park and disconnect your trailer on a slope. What must you do before unhitching?',
    options: [
      { id: 'q-spd-13o1', text: 'Nothing — the tow ball coupling is sufficient to hold it' },
      { id: 'q-spd-13o2', text: 'Apply the trailer handbrake and place wheel chocks under the wheels' },
      { id: 'q-spd-13o3', text: 'Lower the jockey wheel only' },
      { id: 'q-spd-13o4', text: 'Leave the vehicle in reverse gear as a brake' },
    ],
    answerId: 'q-spd-13o2',
    explanation: 'Before unhitching a trailer on a slope, apply the trailer handbrake and place wheel chocks (wiggen) under the wheels to prevent it rolling away. Relying on the coupling alone is dangerous — an uncoupled trailer can roll and cause serious accidents.',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-14',
    topic: 'General',
    question: 'When reversing with a trailer, which way do you turn the steering wheel to make the trailer go right?',
    options: [
      { id: 'q-spd-14o1', text: 'Turn right — the same direction as when driving forward' },
      { id: 'q-spd-14o2', text: 'Turn left — opposite to the direction you want the trailer to go' },
      { id: 'q-spd-14o3', text: 'The trailer always follows the vehicle automatically' },
      { id: 'q-spd-14o4', text: 'Keep the wheel straight and use brakes to steer' },
    ],
    answerId: 'q-spd-14o2',
    explanation: 'When reversing with a trailer, the trailer moves in the opposite direction to the steering wheel. To make the trailer go right, you turn the steering wheel left. This is the opposite of normal driving and requires practice. Make small steering corrections to avoid jackknifing.',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-15',
    topic: 'General',
    question: 'You want to tow a caravan. The caravan\'s maximum permitted mass is 1,200 kg and it has its own brakes. What is the maximum speed on a 100 km/h road outside a built-up area?',
    options: [
      { id: 'q-spd-15o1', text: '100 km/h' },
      { id: 'q-spd-15o2', text: '90 km/h' },
      { id: 'q-spd-15o3', text: '80 km/h' },
      { id: 'q-spd-15o4', text: '70 km/h' },
    ],
    answerId: 'q-spd-15o2',
    explanation: 'When towing any trailer or caravan with a category B licence, the maximum speed outside built-up areas (including roads with a 100 km/h limit) is 90 km/h. This applies regardless of whether the trailer has brakes or what the general road limit is. (RVV 1990 art. 22)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-16',
    topic: 'General',
    question: 'Which of the following correctly describes the safety chain (or breakaway cable) on a trailer?',
    options: [
      { id: 'q-spd-16o1', text: 'It is optional and only needed on trailers over 1,500 kg' },
      { id: 'q-spd-16o2', text: 'It connects the trailer brakes to the towing vehicle so the trailer brakes apply automatically if it becomes uncoupled' },
      { id: 'q-spd-16o3', text: 'It prevents the trailer from swaying at high speed' },
      { id: 'q-spd-16o4', text: 'It is a decorative chain with no safety function' },
    ],
    answerId: 'q-spd-16o2',
    explanation: 'The breakaway cable (losrijkabel) connects the trailer\'s handbrake mechanism to the towing vehicle. If the trailer accidentally uncouples, the cable pulls the trailer handbrake on, slowing the trailer and preventing a runaway. It is required on braked trailers. (Voertuigreglement)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-17',
    topic: 'General',
    question: 'You are carrying a long ladder on your roof rack. It extends 1.5 metres beyond the rear of your car. What marking is required?',
    options: [
      { id: 'q-spd-17o1', text: 'A red flag only' },
      { id: 'q-spd-17o2', text: 'A red/white striped board with a red reflector at the end' },
      { id: 'q-spd-17o3', text: 'Yellow flashing lights on the roof' },
      { id: 'q-spd-17o4', text: 'No marking needed below 2 metres overhang' },
    ],
    answerId: 'q-spd-17o2',
    explanation: 'Any load protruding more than 1 metre beyond the rear of the vehicle must be marked with a red/white striped board (gevaarbord) and a red reflector at the very end. At night, a red light is also required. This warns following traffic of the hazard. (RVV 1990 art. 76)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-18',
    topic: 'General',
    question: 'What does a vehicle\'s "towing capacity" (trekgewicht) mean?',
    options: [
      { id: 'q-spd-18o1', text: 'The maximum weight the vehicle\'s roof rack can carry' },
      { id: 'q-spd-18o2', text: 'The maximum permitted mass of a trailer that the vehicle is approved to tow' },
      { id: 'q-spd-18o3', text: 'The combined weight of vehicle and trailer when fully loaded' },
      { id: 'q-spd-18o4', text: 'The maximum load you can carry inside the vehicle' },
    ],
    answerId: 'q-spd-18o2',
    explanation: 'The towing capacity (trekgewicht) is the maximum permitted trailer mass the vehicle is engineered and approved to tow. This figure is stated in the vehicle\'s registration document (kentekenbewijs). Exceeding it is illegal and dangerous — it affects braking, stability, and tyre load.',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-19',
    topic: 'General',
    question: 'You arrive at a motorway with a trailer. Which lane must you use?',
    options: [
      { id: 'q-spd-19o1', text: 'Any lane, including the overtaking lane, as long as you keep to 90 km/h' },
      { id: 'q-spd-19o2', text: 'The right-hand lane only — you may not use the overtaking lane when towing' },
      { id: 'q-spd-19o3', text: 'The middle lane to keep distance from merging traffic' },
      { id: 'q-spd-19o4', text: 'Any lane except the far-right lane' },
    ],
    answerId: 'q-spd-19o2',
    explanation: 'When towing a trailer, you must stay in the right-hand lane on a motorway and may not use the overtaking (left) lane. On motorways with three or more lanes, vehicles towing trailers are restricted to the two rightmost lanes. (RVV 1990 art. 12)',
    subject: 'Specialized Driving',
  },
  {
    id: 'q-spd-20',
    topic: 'General',
    question: 'Before setting off with a trailer, you must check the tow ball coupling is correctly locked. How do you verify this?',
    options: [
      { id: 'q-spd-20o1', text: 'Drive slowly for 10 metres — if the trailer stays attached it is secure' },
      { id: 'q-spd-20o2', text: 'Lift the trailer jockey wheel to confirm the coupling clamps onto the ball, the locking pin is inserted, and the breakaway cable is attached' },
      { id: 'q-spd-20o3', text: 'Check that the trailer lights work — if they do, the coupling must be secure' },
      { id: 'q-spd-20o4', text: 'It is the trailer owner\'s responsibility, not the driver\'s' },
    ],
    answerId: 'q-spd-20o2',
    explanation: 'Before moving off, physically verify: (1) the coupling head is fully clamped onto the tow ball, (2) the locking pin or safety clip is in place, and (3) the breakaway cable is connected to the towing vehicle. Also raise and secure the jockey wheel. Connecting trailer lights alone does not confirm the coupling is safe.',
    subject: 'Specialized Driving',
  },
];
